export { default as BaseUrlRespectLink } from './base-url-respected-link';
